import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@material-ui/core";
import NotificationProvider from "components/NotificationProvider";
import { TabsWrapper } from "components/TabsWrapper/TabsWrapper";
import { useEffect, useState } from "react";
import configStyles from "../configStyles";
import WashConfig from "./WashConfig";
import { useGetSlaCycleDefinitionQuery, useSaveWashProgramConfigMutation } from "./washProgramSlice";
import WashRules from "./WashRules";


const useStyles = configStyles;

const WashConfigDialog = ({ contract, handleClose, clientConfig, open }) => {
    const classes = useStyles();
    var clientId = clientConfig?.id;

    const [isSaving, setIsSaving] = useState(false);
    const [configFields, setConfigFields] = useState({});
    const [cycleFields, setCycleFields] = useState({});
    const [localClientConfig, setLocalClientConfig] = useState({});
    const [mechanicalsRulesToEdit, setMechanicalsRulesToEdit] = useState([])

    const { data: cycleDefinition, isLoading } = useGetSlaCycleDefinitionQuery(clientId, { skip: !clientId });
    const [saveWashProgramConfig, { isLoading: isSavingWashProgram }] = useSaveWashProgramConfigMutation();


    useEffect(() => {
        if (open && cycleDefinition) {
            setCycleFields(cycleDefinition);
        }
    }, [open, cycleDefinition]);

    useEffect(() => {
        if (clientConfig) {
            setLocalClientConfig(clientConfig);
            const washConfigParams = clientConfig?.config?.washConfig;
            setConfigFields({ ...configFields, ...washConfigParams });
        }
    }, [clientConfig])

    const onChangeConfigField = (configName, field, value) => {
        setLocalClientConfig(configName ? { ...localClientConfig, config: { ...localClientConfig?.config, [configName]: { ...localClientConfig?.config?.[configName], [field]: value } } } : { ...localClientConfig, [field]: value });
        setConfigFields({ ...configFields, [field]: value });
    }

    const onChangeCycleField = (field, value) => {
        setCycleFields({ ...cycleFields, [field]: value });
    }

    const handleSave = async () => {
        setIsSaving(true);

        let objectToSave = {
            clientId,
            ...configFields,
            ...cycleFields
        };
        let res = await saveWashProgramConfig(objectToSave);

        setIsSaving(false);
        handleClose();

        if (!res?.error) {
            NotificationProvider.success('Saved successfully');
            onClose();
        } else {
            NotificationProvider.error('Failed to save');
        }
    };

    const onClose = () => {
        setCycleFields({});
        handleClose();
    }


    const tabs = [
        {
            label: 'Configuration',
            component: <WashConfig
                clientToEdit={localClientConfig}
                onConfigChange={onChangeConfigField}
                cycleFields={cycleFields}
                onChangeCycleField={onChangeCycleField}
            />
        },
        {
            label: 'Automation Logic',
            component: <WashRules
                clientId={localClientConfig?.id}
                onClose={() => setMechanicalsRulesToEdit([])}
                clientLots={localClientConfig?.clientLots}
                mechanicalsRulesToEdit={mechanicalsRulesToEdit}
                setMechanicalsRulesToEdit={setMechanicalsRulesToEdit}
            />
        },
    ]

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth='lg'
        >
            <DialogTitle>
                <Grid container justifyContent='space-between'>
                    <div>{`${contract?.label} SLA`}</div>
                    {contract?.headerComponent}
                </Grid>
            </DialogTitle>
            <DialogContent >
                <TabsWrapper tabs={tabs} />
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={handleSave}
                    disabled={isSaving}
                    className={classes.button}
                    variant="outlined"
                    color="primary"
                >
                    {isSaving ? "Saving..." : "Save"}
                </Button>
            </DialogActions>

        </Dialog >
    )
}
export default WashConfigDialog;